import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { TimelineLegLocation } from "../TimelineLegLocation/index.js";
import styles from "./styles.module.css";
export const TimelineLeg = ({ departure, arrival, contentBetweenDepartureAndArrival, contentOnSide, className, attributes, isResponsiveFixesSm }) => {
    return (React.createElement(Stack, { direction: isResponsiveFixesSm ? "column-reverse" : "row", gap: 8, alignItems: isResponsiveFixesSm ? "start" : "center", className: className, attributes: attributes },
        React.createElement("div", { className: styles.mainColumn },
            React.createElement("div", { className: styles.departureHolder },
                React.createElement("div", { className: styles.connector }),
                React.createElement(TimelineLegLocation, { ...departure }),
                contentBetweenDepartureAndArrival),
            React.createElement("div", { className: styles.arrivalHolder },
                React.createElement(TimelineLegLocation, { ...arrival }))),
        contentOnSide && React.createElement("div", { className: styles.sideColumn }, contentOnSide)));
};
